//
// rest api
//

let _stripe_key = "pk_test_MWMNUtwQVmGyq7OyF1gr4zqf00L3z6jzV2"
let _api_url = 'https://alphatest.shabelab.com'
if ( window.location.hostname === "localhost" ) {
  _api_url = 'https://alphatest.shabelab.com'
  _stripe_key = 'pk_test_MWMNUtwQVmGyq7OyF1gr4zqf00L3z6jzV2'
} else if ( window.location.hostname === "alpha.shabelab.com" ) {
  _api_url = 'https://alpha.shabelab.com'
  _stripe_key = 'pk_live_SOUGnl92HYehm40z3PuXNIK900FJCLFPBZ'
}
export const API_URL = _api_url
export const API_KEY = 'szFx0FbatrocDeeb'
export const LOCAL_STRAGE_KEY = "__ALPHA_SHABELAB__"
export const STRIPE_KEY = _stripe_key
